// import { alpha } from '@mui/material/styles';

// // ----------------------------------------------------------------------

// function createGradient(color1, color2) {
//   return `linear-gradient(to bottom, ${color1}, ${color2})`;
// }

// // SETUP COLORS
// const GREY = {
//   0: '#FFFFFF',
//   100: '#F9FAFB',
//   200: '#F4F6F8',
//   300: '#DFE3E8',
//   400: '#C4CDD5',
//   500: '#919EAB',
//   600: '#637381',
//   700: '#454F5B',
//   800: '#212B36',
//   900: '#161C24',
//   500_8: alpha('#919EAB', 0.08),
//   500_12: alpha('#919EAB', 0.12),
//   500_16: alpha('#919EAB', 0.16),
//   500_24: alpha('#919EAB', 0.24),
//   500_32: alpha('#919EAB', 0.32),
//   500_48: alpha('#919EAB', 0.48),
//   500_56: alpha('#919EAB', 0.56),
//   500_80: alpha('#919EAB', 0.8),
// };

// const PRIMARY = {
//   lighter: '#aab8d1',   // Light tint for backgrounds (30% opacity white on main)
//   light: '#4a5f8c',     // Mid tint for hover/focus
//   main: '#031D49',      // Deep navy blue (your base)
//   dark: '#02163a',      // Slightly darker for active states
//   darker: '#010d21',    // Almost black navy for high contrast
//   contrastText: '#ffffff', // Ensures readable text on all shades
// };


// const SECONDARY = {
//   lighter: '#D6E4FF',
//   light: '#84A9FF',
//   main: '#3366FF',
//   dark: '#1939B7',
//   darker: '#091A7A',
//   contrastText: '#fff',
// };

// const INFO = {
//   lighter: '#D0F2FF',
//   light: '#74CAFF',
//   main: '#1890FF',
//   dark: '#0C53B7',
//   darker: '#04297A',
//   contrastText: '#fff',
// };

// const SUCCESS = {
//   lighter: '#E9FCD4',
//   light: '#AAF27F',
//   main: '#54D62C',
//   dark: '#229A16',
//   darker: '#08660D',
//   contrastText: GREY[800],
// };

// const WARNING = {
//   lighter: '#FFF7CD',
//   light: '#FFE16A',
//   main: '#FFC107',
//   dark: '#B78103',
//   darker: '#7A4F01',
//   contrastText: GREY[800],
// };

// const ERROR = {
//   lighter: '#FFE7D9',
//   light: '#FFA48D',
//   main: '#FF4842',
//   dark: '#B72136',
//   darker: '#7A0C2E',
//   contrastText: '#fff',
// };

// const GRADIENTS = {
//   primary: createGradient(PRIMARY.light, PRIMARY.main),
//   info: createGradient(INFO.light, INFO.main),
//   success: createGradient(SUCCESS.light, SUCCESS.main),
//   warning: createGradient(WARNING.light, WARNING.main),
//   error: createGradient(ERROR.light, ERROR.main),
// };

// const CHART_COLORS = {
//   violet: ['#826AF9', '#9E86FF', '#D0AEFF', '#F7D2FF'],
//   blue: ['#2D99FF', '#83CFFF', '#A5F3FF', '#CCFAFF'],
//   primary: ['#2CD9C5', '#60F1C8', '#A4F7CC', '#C0F2DC'],
//   green: ['#2CD9C5', '#60F1C8', '#A4F7CC', '#C0F2DC'],
//   yellow: ['#FFE700', '#FFEF5A', '#FFF7AE', '#FFF3D6'],
//   orange: ['#FF6C40', '#FF8F6D', '#FFBD98', '#FFF2D4'],
//   red: ['#ff5252', '#fc6060', '#ff6e6e', '#fc7e7e'],
// };

// const palette = {
//   common: { black: '#000', white: '#fff' },
//   primary: { ...PRIMARY },
//   secondary: { ...SECONDARY },
//   info: { ...INFO },
//   success: { ...SUCCESS },
//   warning: { ...WARNING },
//   error: { ...ERROR },
//   grey: GREY,
//   gradients: GRADIENTS,
//   chart: CHART_COLORS,
//   divider: GREY[500_24],
//   text: { primary: GREY[800], secondary: GREY[600], disabled: GREY[500] },
//   background: { paper: '#fff', default: GREY[100], neutral: GREY[200] },
//   action: {
//     active: GREY[600],
//     hover: GREY[500_8],
//     selected: GREY[500_16],
//     disabled: GREY[500_80],
//     disabledBackground: GREY[500_24],
//     focus: GREY[500_24],
//     hoverOpacity: 0.08,
//     disabledOpacity: 0.48,
//   },
// };

// export default palette;


import { alpha } from '@mui/material/styles';

function createGradient(color1, color2) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`;
}

// GREY SCALE FOR DARK MODE
const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#182335', // Dark neutral surface (cards/tables)
  900: '#0B1220', // Main app background
  500_8: alpha('#919EAB', 0.08),
  500_12: alpha('#919EAB', 0.12),
  500_16: alpha('#919EAB', 0.16),
  500_24: alpha('#919EAB', 0.24),
  500_32: alpha('#919EAB', 0.32),
  500_48: alpha('#919EAB', 0.48),
  500_56: alpha('#919EAB', 0.56),
  500_80: alpha('#919EAB', 0.8),
};

// const WHITE = {
//   0: '#FFFFFF',
//   100: alpha('#FFFFFF', 0.04),
//   200: alpha('#FFFFFF', 0.08),
//   300: alpha('#FFFFFF', 0.12),
//   400: alpha('#FFFFFF', 0.16),
//   500: alpha('#FFFFFF', 0.24),
//   600: alpha('#FFFFFF', 0.32),
//   700: alpha('#FFFFFF', 0.48),
//   800: alpha('#FFFFFF', 0.56),
//   900: alpha('#FFFFFF', 0.8),
//   1000: alpha('#FFFFFF', 1), // Same as WHITE.0
// };

const PRIMARY = {
  lighter: '#adc2ff',
  light: '#7ea0ff',
  main: '#4862d6',
  dark: '#4a66cc',
  darker: '#374d99',
  contrastText: '#FFFFFF',
};

const SECONDARY = {
  lighter: '#FFD6F9',
  light: '#EA80FC',
  main: '#C400FF',
  dark: '#7900A9',
  darker: '#4A0072',
  contrastText: '#FFFFFF',
};

const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#00B8D9',
  dark: '#006C9C',
  darker: '#003768',
  contrastText: '#FFFFFF',
};

const SUCCESS = {
  lighter: '#D9F99D',
  light: '#A3E635',
  main: '#65A30D',
  dark: '#3F6212',
  darker: '#1E3A08',
  contrastText: '#000000',
};

const WARNING = {
  lighter: '#FDE68A',
  light: '#FACC15',
  main: '#EAB308',
  dark: '#B45309',
  darker: '#78350F',
  contrastText: '#000000',
};

const ERROR = {
  lighter: '#FCA5A5',
  light: '#F87171',
  main: '#EF4444',
  dark: '#B91C1C',
  darker: '#7F1D1D',
  contrastText: '#FFFFFF',
};

const GRADIENTS = {
  primary: createGradient(PRIMARY.light, PRIMARY.main),
  info: createGradient(INFO.light, INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main),
};

const CHART_COLORS = {
  violet: ['#B794F4', '#9F7AEA', '#805AD5', '#6B46C1'],
  blue: ['#63B3ED', '#4299E1', '#3182CE', '#2B6CB0'],
  primary: ['#3056D3', '#4a6ee0', '#A5B4FC', '#D1D5DB'],
  green: ['#34D399', '#10B981', '#059669', '#047857'],
  yellow: ['#FCD34D', '#FBBF24', '#F59E0B', '#D97706'],
  orange: ['#FB923C', '#F97316', '#EA580C', '#C2410C'],
  red: ['#F87171', '#EF4444', '#DC2626', '#B91C1C'],
};

const palette = {
  mode: 'dark',
  common: { black: '#000000', white: '#ffffff' },
  primary: { ...PRIMARY },
  secondary: { ...SECONDARY },
  info: { ...INFO },
  success: { ...SUCCESS },
  warning: { ...WARNING },
  error: { ...ERROR },
  grey: GREY,
  gradients: GRADIENTS,
  chart: CHART_COLORS,
  divider: GREY[500_12],
  text: {
    primary: '#fff',
    secondary: GREY[500],
    disabled: GREY[600],
  },
  background: {
    paper: '#121a29',     // Cards, panels
    default: '#0B1220',   // App background
    neutral: '#182335',   // Extra surfaces
  },
  action: {
    active: GREY[500],
    hover: GREY[500_8],
    selected: GREY[500_16],
    disabled: GREY[500_80],
    disabledBackground: GREY[500_24],
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;

